module.exports = __webpack_public_path__ + "8a2c7a1f63e190babdb69a575bc3dbde.svg";